// Firebase functions
export const getActiveEvents = 'getActiveBountyEvents';
export const oracleCollectEmail = 'oracleCollectEmail';
export const getLeaderboard = 'getLeaderboard';
export const getEventBets = 'getGameBets';
export const getBountyUserBets = 'getBountyUserBets';
export const getUserStats = 'getUserStats';
export const postEventBet = 'makeBountyBet';
export const getEventDetails = 'getBountyEventDetails';
export const getEventDetailsBets = 'getRecentBets';


export const APP_STARTUP = 'APP_STARTUP';
export const APP_STARTUP_DOM = 'APP_STARTUP_DOM';
export const APP_STARTUP_NAV = 'APP_STARTUP_NAV';
export const APP_STARTUP_USER = 'APP_STARTUP_USER';
export const APP_STARTUP_SOCKET = 'APP_STARTUP_SOCKET';
export const APP_STARTUP_NETWORK = 'APP_STARTUP_NETWORK';
export const APP_STARTUP_METAMASK = 'APP_STARTUP_METAMASK';
export const APP_STARTUP_COMPLETE = 'APP_STARTUP_COMPLETE';

export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR';
export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';

export const FETCH_FAIL = 'FETCH_FAIL';
export const FETCH_IS_FETCHING = 'FETCH_IS_FETCHING';

// User

export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_BALANCES = 'USER_UPDATE_BALANCES';
export const USER_UPDATE_BALANCES_ERROR = 'USER_UPDATE_BALANCES_ERROR';

export const USER_AUTH_LOGOUT = 'USER_AUTH_LOGOUT';
export const USER_AUTH_LOGOUT_FAIL = 'USER_AUTH_LOGOUT_FAIL';
export const USER_AUTH_LOGOUT_SUCCESS = 'USER_AUTH_LOGOUT_SUCCESS';

export const USER_AUTH_LOGIN = 'USER_AUTH_LOGIN';
export const USER_AUTH_LOGIN_FAIL = 'USER_AUTH_LOGIN_FAIL';
export const USER_AUTH_LOGIN_SUCCESS = 'USER_AUTH_LOGIN_SUCCESS';

export const USER_AUTH_REGISTER = 'USER_AUTH_REGISTER';
export const USER_AUTH_REGISTER_FAIL = 'USER_AUTH_REGISTER_FAIL';
export const USER_AUTH_REGISTER_SUCCESS = 'USER_AUTH_REGISTER_SUCCESS';

export const USER_FETCH_STATS = 'USER_FETCH_STATS';
export const USER_FETCH_STATS_ERROR = 'USER_FETCH_STATS_ERROR';
export const USER_FETCH_STATS_SUCCESS = 'USER_FETCH_STATS_SUCCESS';

export const USER_FETCH_BETS = 'USER_FETCH_BETS';
export const USER_FETCH_BETS_LOADING = 'USER_FETCH_BETS_LOADING'
export const USER_FETCH_BETS_ERROR = 'USER_FETCH_BETS_ERROR';
export const USER_FETCH_BETS_SUCCESS = 'USER_FETCH_BETS_SUCCESS';

export const USER_SET_ETH_ADDRESS = 'USER_SET_ETH_ADDRESS';
export const USER_SET_ETH_ADDRESS_ERROR = 'USER_SET_ETH_ADDRESS_ERROR';
export const USER_SET_ETH_ADDRESS_SUCCESS = 'USER_SET_ETH_ADDRESS_SUCCESS';

export const FETCH_LEADERS = 'FETCH_LEADERS';
export const FETCH_LEADERS_ERROR = 'FETCH_LEADERS_ERROR';
export const FETCH_LEADERS_LOADING = 'FETCH_LEADERS_LOADING';
export const FETCH_LEADERS_SUCCESS = 'FETCH_LEADERS_SUCCESS';

export const FETCH_USER_NUMBER = 'FETCH_USER_NUMBER';
export const FETCH_USER_NUM_SUCCESS = 'FETCH_USER_NUM_SUCCESS';

export const LEADERS_UPDATE = 'LEADERS_UPDATE';

export const NAV = 'NAV';
export const NAV_MINIFIED = 'NAV_MINIFIED';
export const SCREEN_GAME = 'Game';
export const SCREEN_AUTH = 'Auth';
export const SCREEN_GENERAL_LOBBY = 'Lobby';
export const SCREEN_GENERAL_INTRO = 'Intro';
export const SCREEN_USER_SET_REFERRAL = 'UserSetReferral';
export const SCREEN_USER_SET_USERNAME = 'UserSetUsername';
export const SCREEN_USER_AUTH_REGISTER = 'UserAuthRegister';

export const ADDRESS_ORACLES_CONTROLLER = 'ADDRESS_ORACLES_CONTROLLER';

export const EVENTS_UPDATE = 'EVENTS_UPDATE';
export const EVENT_UPDATE = 'EVENT_UPDATE';
export const EVENTS_SET_ACTIVE = 'EVENTS_SET_ACTIVE';

export const EVENTS_POST_BET = 'EVENTS_POST_BET';
export const EVENTS_POST_BET_ERROR = 'EVENTS_POST_BET_ERROR';

export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';

export const USER_POST_BET = 'USER_POST_BET';
export const USER_POST_BET_ERROR = 'USER_POST_BET_ERROR';
export const USER_POST_BET_SUCCESS = 'USER_POST_BET_SUCCESS';

// Bets

export const BET_SELECT = 'BET_SELECT';

export const FETCH_GAME_BETS = 'FETCH_GAME_BETS';
export const FETCH_GAME_BETS_ERROR = 'FETCH_GAME_BETS_ERROR';

export const FETCH_TEAM = 'FETCH_TEAM';
export const FETCH_TEAM_ERROR = 'FETCH_TEAM_ERROR';
export const FETCH_TEAM_LOADING = 'FETCH_TEAM_LOADING';
export const FETCH_TEAM_SUCCESS = 'FETCH_TEAM_SUCCESS';

export const FETCH_EVENT_DETAILS_BETS = 'FETCH_EVENT_DETAILS_BETS';
export const FETCH_EVENT_DETAILS_BETS_ERROR = 'FETCH_EVENT_DETAILS_BETS_ERROR';
export const FETCH_EVENT_DETAILS_BETS_SUCCESS = 'FETCH_EVENT_DETAILS_BETS_SUCCESS';
export const FETCH_EVENT_DETAILS_BETS_LOADING = 'FETCH_EVENT_DETAILS_BETS_LOADING';

export const FETCH_EVENT = 'FETCH_EVENT';
export const FETCH_EVENT_ERROR = 'FETCH_EVENT_ERROR';
export const FETCH_EVENT_LOADING = 'FETCH_EVENT_LOADING';
export const FETCH_EVENT_SUCCESS = 'FETCH_EVENT_SUCCESS';

export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_EVENTS_ERROR = 'FETCH_EVENTS_ERROR';
export const FETCH_EVENTS_LOADING = 'FETCH_EVENTS_LOADING';
export const FETCH_EVENTS_SUCCESS = 'FETCH_EVENTS_SUCCESS';



export const ORACLE_COLLECT_EMAILS = 'ORACLE_COLLECT_EMAILS';
export const ORACLE_COLLECT_EMAILS_FAIL = 'ORACLE_COLLECT_EMAILS_FAIL';

// App display

export const MENU_TOGGLE = 'MENU_TOGGLE';
export const SHOW_NAV = 'SHOW_NAV';
export const NAV_BACK = 'NAV_BACK';

// Modals

export const MODAL_EVENT_BET_POSTED = 'MODAL_EVENT_BET_POSTED';
export const MODAL_USER_PROMPT_LOGIN = 'MODAL_USER_PROMPT_LOGIN';
export const MODAL_INCORRECT_NETWORK = 'MODAL_INCORRECT_NETWORK';
export const MODAL_USER_SET_ETH_ADDRESS = 'MODAL_USER_SET_ETH_ADDRESS';
export const MODAL_ORACLE_COLLECT_EMAILS = 'MODAL_ORACLE_COLLECT_EMAILS';
export const MODAL_METAMASK_NOT_INSTALLED = 'MODAL_METAMASK_NOT_INSTALLED';
export const MODAL_METAMASK_NOT_CONFIGURED = 'MODAL_METAMASK_NOT_CONFIGURED';

// Game

export const GAME_UPDATE = 'GAME_UPDATE';
export const GAME_GET_STATUS = 'GAME_GET_STATUS';
export const GAME_USER_UPDATE = 'GAME_USER_UPDATE';
export const GAME_USER_SELECT_ANSWER = 'GAME_USER_SELECT_ANSWER';

// Game event
export const GAME_ON_QUESTION_COMPLETE = 'GAME_ON_QUESTION_COMPLETE';
export const GAME_SET_TIME_TO_OPENING_CREDITS = 'GAME_SET_TIME_TO_OPENING_CREDITS';
// Game nav
export const GAME_SET_SCREEN = 'GAME_SET_SCREEN';
export const GAME_SET_QUESTION = 'GAME_SET_QUESTION';

// snackbar
export const SNACKBAR_SHOW = 'SNACKBAR_SHOW';
export const SNACKBAR_HIDE = 'SNACKBAR_HIDE';
export const SNACKBAR_NO_ETH_ADDRESS = 'SNACKBAR_NO_ETH_ADDRESS'



// WEBPACK FOOTER //
// ./src/constants/action-types.js